import script from "./TeamTax.vue?vue&type=script&setup=true&lang=js"
export * from "./TeamTax.vue?vue&type=script&setup=true&lang=js"

import "./TeamTax.vue?vue&type=style&index=0&id=d8afe570&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d8afe570"]])

export default __exports__